import { render, staticRenderFns } from "./Menulist.vue?vue&type=template&id=ef543f58&scoped=true&"
import script from "./Menulist.vue?vue&type=script&lang=js&"
export * from "./Menulist.vue?vue&type=script&lang=js&"
import style0 from "./Menulist.vue?vue&type=style&index=0&id=ef543f58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef543f58",
  null
  
)

export default component.exports